import Call from '../Call';

const AdkPartners = {
    get() {
        return Call(`adkPartner`);
    },

    save(feed) {
        return Call('adkPartner','POST', feed);
    },

    update(id, entity) {
        return Call(`adkPartner/${id}`,'PUT', { entity });
    },

    remove(id) {
        return Call(`adkPartner/${id}`,'DELETE');
    }
};

export default AdkPartners;



// WEBPACK FOOTER //
// ./src/services/API/components/AdkPartners.js